import { axios, Response } from '..'

type Body = {
  login: string
  password: string
}

type PersonaAuthenticationResponses = {
  firebaseToken: string
  uid: string
}

type UserCredentials = {
  username: string
  accessToken: string
  refreshToken: string
  personaAuthenticationResponses: PersonaAuthenticationResponses[]
}

const login = (body: Body): Response<UserCredentials> => {
  return axios.post('/login', body)
}

export default login
